import React, { useState } from "react";
import { motion } from "framer-motion";
// import MobileRecharge from "./MobileRecharge";
import MobileRecharge1 from "./MobileRecharge1";
import MobileRecharge3 from "./MobileRecharge3";

const MobileRecharge2 = () => {

  const [mode, setMode] = useState("browse");

  return (
    <div className="min-h-screen bg-[#EEF2F8] px-4 py-6">

      <div className="mx-auto">

        {/* HEADER */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-[#1F2A44]">
            Mobile Recharge
          </h2>
          <p className="text-sm text-gray-500">
            Recharge instantly or browse available plans
          </p>
        </div>


        {/* SEGMENTED TAB BAR */}
        <div className="bg-white rounded-2xl shadow-md overflow-hidden flex">
          <button
            onClick={() => setMode("browse")}
            className={`flex-1 py-4 text-center font-semibold transition
            ${mode === "browse"
                ? "bg-[#12345A] text-white"
                : "text-gray-600 hover:bg-gray-50"}`}
          >
            Browse / Fetch Plans
          </button>

          <button
            onClick={() => setMode("direct")}
            className={`flex-1 py-4 text-center font-semibold transition
            ${mode === "direct"
                ? "bg-[#12345A] text-white"
                : "text-gray-600 hover:bg-gray-50"}`}
          >
            Direct Recharge
          </button>


        </div>


        {/* CONTENT AREA */}
        <div className="mt-6">

          <motion.div
            key={mode}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25 }}
          >
            {mode === "direct" && <MobileRecharge3 />}
            {mode === "browse" && <MobileRecharge1 />}
          </motion.div>

        </div>

      </div>

    </div>
  );
};

export default MobileRecharge2;